import { render, staticRenderFns } from "./OperaProjectWindow.vue?vue&type=template&id=3f00f716&scoped=true&"
import script from "./OperaProjectWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectWindow.vue?vue&type=style&index=0&id=3f00f716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00f716",
  null
  
)

export default component.exports